import { useEffect, useState } from 'react';
import useMatchMedia from 'utils/hooks/useMatchMedia';
import theme from 'mui/base/theme/index';

export function useSelectLocationScroll({
  locationsWrapperRef,
  locationsRefs,
  selectedLocation,
  isBookingFunnel,
  mounted,
}) {
  const desktopBreakpoint = theme.breakpoints.values.lg;
  const isDesktop = useMatchMedia(`(min-width: ${desktopBreakpoint}em)`);

  const [locationRef, setLocationRef] = useState(null);

  // Scroll to selected location on the locations list
  useEffect(() => {
    if (!selectedLocation) return;
    setLocationRef(locationsRefs[selectedLocation.id]);
    if (locationRef?.current && locationsWrapperRef?.current) {
      const moveOptions =
        isBookingFunnel && isDesktop
          ? locationRef.current.offsetTop
          : isBookingFunnel && !isDesktop
          ? locationRef.current.offsetTop - 402
          : 24;
      const scrollDirection = isDesktop || isBookingFunnel ? 'top' : 'left';
      const scrollOptions =
        scrollDirection === 'top'
          ? { top: moveOptions, behavior: 'smooth' }
          : { left: locationRef.current.offsetLeft - 24, behavior: 'smooth' };
      locationsWrapperRef.current.scroll(scrollOptions);
    }
  }, [selectedLocation, isDesktop, mounted, locationRef]);

  return {
    locationsRefs,
  };
}
